import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, landingForRole } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowLeft, LogOut } from "lucide-react";

export default function AccessDeniedPage() {
  const nav = useNavigate();
  const { user, logout } = useAuth();

  const goHome = () => {
    if (user && user.role) nav(landingForRole(user.role), { replace: true });
    else nav("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6">
      <div className="max-w-xl w-full bg-white border border-slate-200 rounded-2xl p-10 shadow-sm text-center"
           data-testid="access-denied-page">
        <img src={LOGO_URL} alt="MAMA" className="w-16 h-16 mx-auto mb-6" />
        <div className="w-16 h-16 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-5">
          <ShieldAlert className="w-9 h-9 text-[#DC2626]" />
        </div>
        <h1 className="font-display font-black text-3xl text-slate-900 mb-2">Accès refusé</h1>
        <p className="text-slate-600 mb-6">
          Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
          {user?.role ? (
            <> Votre rôle actuel est <span className="font-mono font-bold uppercase tracking-widest">{user.role}</span>.</>
          ) : null}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button onClick={goHome} className="bg-[#DC2626] hover:bg-[#B91C1C]" data-testid="access-denied-home">
            <ArrowLeft className="w-4 h-4 mr-2" /> Retour à mon espace
          </Button>
          {user && (
            <Button variant="outline" onClick={logout} data-testid="access-denied-logout">
              <LogOut className="w-4 h-4 mr-2" /> Changer de compte
            </Button>
          )}
        </div>
        <div className="mt-8 text-xs text-slate-400">
          Si vous pensez qu'il s'agit d'une erreur, contactez l'administrateur de votre agence.
        </div>
      </div>
    </div>
  );
}
